import { fireCmdbErrorAnalytics } from '@atlassian/jira-servicedesk-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { performCmdbGetRequest } from '@atlassian/jira-servicedesk-cmdb-client/src/fetch.tsx';
import { getCmdbObjectTypeByIdAttributesUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/object-type.tsx';
import { toAttributeType } from '@atlassian/jira-servicedesk-insight-object-types/src/common/utils/normalization/index.tsx';
import { isSignal } from '@atlassian/jira-servicedesk-insight-shared-utils/src/common/utils/use-fetch-error/index.tsx';
import type { Action } from '@atlassian/react-sweet-state';
import type { InsightObjectViewState, ContainerProps } from '../../../../common/types/index.tsx';

export const fetchEditableAttributeTypes =
	(): Action<InsightObjectViewState, ContainerProps> =>
	async ({ getState, setState }, { workspaceId, createAnalyticsEvent }) => {
		try {
			const { objectDetails } = getState();
			if (objectDetails) {
				const { objectType } = objectDetails;
				const { id: objectTypeId } = objectType;
				const attributeTypes = await performCmdbGetRequest(
					getCmdbObjectTypeByIdAttributesUrl(workspaceId, objectTypeId, {
						onlyValueEditable: true,
					}),
				);
				setState({
					objectDetails: {
						...objectDetails,
						// @ts-expect-error - TS7006 - Parameter 'attributeType' implicitly has an 'any' type.
						editableAttributeTypes: attributeTypes.map((attributeType) => {
							const { type, ...rest } = attributeType;
							return { ...rest, type: toAttributeType(type) };
						}),
					},
				});
				fireTrackAnalytics(createAnalyticsEvent({}), 'fetchEditableAttributeTypes succeeded');
			}
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({ error });
			if (isSignal(error)) {
				fireCmdbErrorAnalytics({
					meta: {
						id: 'fetchEditableAttributeTypes',
						packageName: 'jiraServicedeskInsightObjectDetailsStore',
						teamName: 'falcons',
					},
					error,
				});
			}
		}
	};
